import type { GlobalImport } from '../shared/interfaces';

import { afterSuccessAction } from './shared/after-success-action';
import { FormWidgetBase } from './shared/form-widget-base';
import { getUtmTagsToMetadata } from './shared/get-utm-tags-to-metadata';
import { recaptchaReady } from './shared/recaptcha-ready';
import { requestWithRecaptchaV3 } from './shared/request';
import { accountInfoLabels, addressInfoLabels, addressInfoOptionalLabels, planPurchaseLabels } from './shared/selectors';

class GiftMembershipCodePurchaseWidget extends FormWidgetBase {
    override requiredImports: GlobalImport[] = [`recaptchaV3`, `recurly`];
    override requiredInfo = [...accountInfoLabels, ...addressInfoLabels, ...planPurchaseLabels];
    override optionalInfo = [...addressInfoOptionalLabels];

    async submit(info: any) {
        const custom_fields = [
            {
                name: `metadata`,
                value: JSON.stringify(getUtmTagsToMetadata()),
            },
        ];

        const body = {
            address: {
                city: info.city,
                country: info.country,
                postal_code: info.postal_code,
                region: info.region,
                street1: info.street1,
                ...(info.phone && {
                    phone: info.phone,
                }),
                ...(info.street2 && {
                    street2: info.street2,
                }),
            },
            billing_info: {
                currency: info.payment_currency,
            },
            custom_fields,
            email: info.email_address,
            first_name: info.first_name,
            last_name: info.last_name,
            subscription: {
                plan_code: info.plan_code,
            },
        };

        const token = await window.mhRecurly.tokenAsync();

        await recaptchaReady();
        const couponsPurchaseResponse = await requestWithRecaptchaV3({
            apiUrl: window.mh.apiUrl,
            data: {
                currency: `USD`,
                plan_id: `code-${info.plan_code}`,
                account: {
                    email: body.email,
                    billing_info: {
                        ...body.billing_info,
                        token_id: token.id,
                    },
                },
            },
            endpoint: `/v1/programs/${window.mh.programSlug}/coupons/purchase`,
            method: `POST`,
            recaptchaV3SiteKey: this.publicConfig.integrations.recaptchaV3.siteKey,
        });

        if (!couponsPurchaseResponse.ok) {
            const json = await couponsPurchaseResponse.json();
            throw new Error(json.error.message ?? json.error);
        }

        if (`afterSuccess` in this.config) {
            afterSuccessAction(this.config.afterSuccess, info);
        }
    }
}

customElements.define(`mh-gift-membership-code-purchase`, GiftMembershipCodePurchaseWidget);

export default GiftMembershipCodePurchaseWidget;
